var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"margin-top-10"},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_c('b-link',{attrs:{"to":{ name: 'jobHome', params: { uuid: _vm.uuid } }}},[_c('strong',[_vm._v(_vm._s(_vm.title))])])],1),_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee5ecee0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/employer/components/JobResult.vue
// module id = null
// module chunks = 